import { Pipe, PipeTransform } from '@angular/core';
import { AddressDataSample } from '@app/core/services/validation-requests/models/address-data-sample.model';

@Pipe({
    name: 'address',
    standalone: false
})
export class AddressPipe implements PipeTransform {

  transform(address: AddressDataSample): any {

    if (address == null) {
      return '-'
    }

    let line1 = ((address.addressNumber ? address.addressNumber: '') +' '+ (address.addressStreet ? address.addressStreet:'' )).trim();

    let line2 = ((address.addressPostalCode ? address.addressPostalCode:'')+ ' '
                + (address.addressCity ? address.addressCity:'')+ ' '
                + (address.addressCountry ? address.addressCountry:'')).trim();


    if (line1 !== '' && line2 !== '') {
      return `${line1}\n${line2}`;
    }
    if (line1 !== '') {
      return line1;
    }
    return line2;
  }

}
